import React from "react";

export default function NoDataRange1() {
  return (
    <>
      <div className="v-title chartbox" style={{marginTop:"44px"}}>
        <div className="chartHGT">
          <div className="alert alert-danger no_data">records not found</div>
          <div style={{ height: "120px" }} ></div>
        </div>
      </div>
    </>
  );
}